import { ACTIONS_TYPES } from "../utils/constants";


export function fetchProjectsRequest() {
  return {
    type: ACTIONS_TYPES.FETCH_PROJECTS_REQUEST,
  }
}

export function fetchProjectsSuccess(response) {
  return {
    type: ACTIONS_TYPES.FETCH_PROJECTS_SUCCESS,
    payload: response,
  }
}

export function fetchProjectsFailed(response) {
  return {
    type: ACTIONS_TYPES.FETCH_PROJECTS_FAILED,
    payload: response,
  }
}

export function registerProjectRequest(payload) {
  return {
    type: ACTIONS_TYPES.REGISTER_PROJECT_REQUEST,
    payload
  }
}

export function registerProjectSuccess(response) {
  return {
    type: ACTIONS_TYPES.REGISTER_PROJECT_SUCCESS,
    payload: response,
  }
}

export function registerProjectFailed(response) {
  return {
    type: ACTIONS_TYPES.REGISTER_PROJECT_FAILED,
    payload: response,
  }
}

export function registerProjectReset() {
  return {
    type: ACTIONS_TYPES.REGISTER_PROJECT_RESET,
  }
}

export function suspendProjectRequest(payload) {
  return {
    type: ACTIONS_TYPES.SUSPEND_PROJECT_REQUEST,
    payload
  }
}

export function suspendProjectSuccess(response) {
  return {
    type: ACTIONS_TYPES.SUSPEND_PROJECT_SUCCESS,
    payload: response,
  }
}

export function suspendProjectFailed(response) {
  return {
    type: ACTIONS_TYPES.SUSPEND_PROJECT_FAILED,
    payload: response,
  }
}

export function SuspendProjectReset() {
  return {
    type: ACTIONS_TYPES.SUSPEND_PROJECT_RESET,
  }
}